import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';

function EmptyApps() {
  const { t } = useTranslation('apps');

  return (
    <PlaceholderContainer
      grow
      icon="apps"
      text={t('noApps')}
      backgroundColor="background.secondary"
    />
  );
}

export default EmptyApps;
